// extracted by mini-css-extract-plugin
module.exports = {"changeLang":"dashboard_changeLang__nJsGF","submitBtn":"dashboard_submitBtn__2JcLS","Header":"dashboard_Header__SGtXj"};